// src/pages/EditProperty/EditProperty.js
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Typography, Box, CircularProgress, Alert } from '@mui/material';
import { propertiesAPI } from '../../services/api';
import PropertyForm from '../../components/PropertyForm/PropertyForm';

const EditProperty = () => {
  const { id } = useParams();
  const [property, setProperty] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const loadProperty = async () => {
      try {
        const response = await propertiesAPI.detail(id);
        setProperty(response.data);
      } catch (error) {
        console.error('Erro ao carregar imóvel:', error);
        setError('Imóvel não encontrado ou você não tem permissão para editá-lo');
      } finally {
        setLoading(false);
      }
    };

    loadProperty();
  }, [id]);

  if (loading) {
    return (
      <Container maxWidth="lg">
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
          <CircularProgress size={60} />
        </Box>
      </Container>
    );
  }

  if (error || !property) {
    return (
      <Container maxWidth="lg">
        <Box sx={{ mt: 4 }}>
          <Alert severity="error">
            {error}
          </Alert>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg">
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
          Editar Imóvel
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Atualize as informações do seu imóvel
        </Typography>
      </Box>

      <PropertyForm property={property} />
    </Container>
  );
};

export default EditProperty;